import React, { useState, useEffect, useRef } from "react";
import Dropdown from "../../components/reuse/formComponets/Dropdown";
import { Link } from "react-router-dom";
import Card from "../../components/products/Card";
import VehicleData from "../../assets/data/vehile";
import Pagination from "../../components/reuse/pagination/pagination";
import Loader from "../../components/loaders/loader1";

function Related() {
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true); 
  const vehiclesPerPage = 12;
  const totalPages = Math.ceil(VehicleData.length / vehiclesPerPage);

  const currentVehicles = VehicleData.slice(
    (currentPage - 1) * vehiclesPerPage,
    currentPage * vehiclesPerPage
  );

  //Auto scroll
  const sectionRef = useRef(null); 
  const handlePageChange = (page) => {
    setCurrentPage(page);
    sectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div
      className="filterDropdown h-full pt-5 lg:px-[10%] md:px-[3.5%] px-[2%] "
      ref={sectionRef}
    >
      <div className="selectOptions flex flex-wrap  lg:gap-4 md:gap-2 gap-3 lg:justify-between">
        <Dropdown option="Select Vehicle" />
        <Dropdown option="Select Brand" />
        <Dropdown option="Select Model" />
        <Dropdown option="Fuel Type" />
        <Dropdown option="Transmission" />
        <div className="flex items-center gap-3">
          <p className="text-lg">Year : </p>
          <Dropdown
            option="Min"
            className="border rounded-md lg:w-[100px] lg:h-[50px] md:w-[80px] md:h-[40px] w-[100px] h-[40px]"
          />
          <Dropdown
            option="Max"
            className="border rounded-md lg:w-[100px] lg:h-[50px] md:w-[80px] md:h-[40px] w-[100px] h-[40px]"
          />
        </div>
        <button className="bg-primary text-white px-4 lg:w-[90px] lg:h-[50px] md:w-[100px] w-[100px] h-[40px] md:h-10 py-1 rounded-md hover:bg-primary-dark">
          <Link to="">Search</Link>
        </button>
      </div>

      <div className="pt-5 flex gap-[40px] flex-wrap justify-center">
        {currentVehicles.map((vehicle) => (
          <Card
            key={vehicle._id}
            MainImage={vehicle.MainImage}
            title={vehicle.title}
            location={vehicle.location}
            model={vehicle.model}
            engin={vehicle.engin}
            fuelType={vehicle.fuelType}
            negotiable={vehicle.negotiable}
          />
        ))}
      </div>

      {/* Pagination component */}
      <div className="pt-5">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
}

export default Related;
